import getAxios from './common/header';
import CurrentUserService from './CurrentUserService';

export default class PartnerDetailsService {
    constructor() {
        this.userService = new CurrentUserService();
    }

    async getPartnerDetails(partnerSelectorId, partnerId) {
        try {
            var response = await getAxios().get(
                `${process.env.VUE_APP_COMMON_BASE_URL}v1/partner-selector/view-partner?id=${partnerSelectorId}&partner_id=${partnerId}`
            );
            return response.data;
        } catch (err) {
            console.error(err.stack);
            return err.response;
        }
    }
    async checkIfAdminHasAgreementWithVendor(isChannel, defaultSubnetworkId, distributorValues) {
        try {
                // Get current user's subnetwork
                const currentUserSubnetwork = isChannel ? this.userService?.marketplaceUser?.subnetworkId : defaultSubnetworkId;
                console.log("Current User >>", this.userService?.marketplaceUser?.subnetworkId, defaultSubnetworkId);
            
            if (!currentUserSubnetwork || !distributorValues || distributorValues.length === 0) {
                console.log("Returning False :: Missing required data", "Distributor Values: ", distributorValues, "currentUserSubnetwork: ", currentUserSubnetwork);
                return false;
            }
            
            // Check if current user's subnetwork matches any distributor's subnetwork
            return distributorValues.some(distributor => 
                distributor.subnetwork_id === currentUserSubnetwork
            );
        } catch (error) {
            console.error("Error in checkIfAdminHasAgreementWithVendor:", error);
            return false;
        }
    }
}
